import MicroModal from 'micromodal';

export default function init() {

    const conf = {
        onShow: modal => console.info(`${modal.id} is shown`), // [1]
        onClose: modal => console.info(`${modal.id} is hidden`), // [2]
        //openTrigger: 'data-custom-open', // [3]
        //closeTrigger: 'data-custom-close', // [4]
        openClass: 'is-open', // [5]
        disableScroll: true, // [6]
        disableFocus: true, // [7]
        awaitOpenAnimation: false, // [8]
        awaitCloseAnimation: false, // [9]
        debugMode: true, // [10]
    };

    MicroModal.init(conf);
}